import en from "../locales/en.json";
// import de from "../lang/de";
// import fr from "../lang/fr";
import es from "../locales/es.json";

export const lang = (value) => {
  // Check if languageSet exists in localStorage
  const languageSet = localStorage.getItem("languageSet");

  // If languageSet exists and is a valid JSON string, parse it; otherwise, use default value
  const lang = { value: "en", label: "English" };

  switch (lang.value) {
    case "en":
      return Capitalize(en[value] || value);
    // case "de":
    //   return de[value] || value;
    // case "fr":
    //   return fr[value] || value;
    case "es":
      return Capitalize(es[value] || value);
    default:
      return Capitalize(value);
  }
};

export function Capitalize(str) {
  if (!str) return ''
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export default lang;
